import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import Retailer from './Retailer';
import Helmet from 'react-helmet';
import config from '../../config';
import TrackedLink from "../common/TrackedLink";

class HatchDetail extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentCountry: null,
			currentRetailers: null
		};

		
	}

	componentDidMount() {
		const productModel = this.props.product.overView;
		//initial state
		window.bvCallback = function (BV) {
			BV.pixel.trackConversion({
			  "type" : "WhereToBuy", 
			  "label" : "value",
			  "value" : productModel.modelNumber
			});
		};

		if (productModel.hatchDetail.retailersUs.length > 0) {
			const retailersUS = productModel.hatchDetail.retailersUs.map(
				(retailer,index) => <Retailer
										key={ index }
										retailer={ retailer }
										productModelNumber={ this.props.product.overView.modelNumber }
									/>
			);

			this.setState({
				currentCountry: 'United States',
				currentRetailers: retailersUS
			});	
		}
	}


	handleChange(e) {		
		const detail = this.props.product.overView.hatchDetail;
		const element = e.target;		
		if (element.value === 'US') {			
			const rus = detail.retailersUs.map(
			(retailer,index) => <Retailer
									key={ index }
									retailer={ retailer }
									productModelNumber={ this.props.product.overView.modelNumber }
								/>
			);

			this.setState({
				currentCountry: 'United States',
				currentRetailers: rus
			});
		} else if (element.value === 'CA') {
			const rca = detail.retailersCa.map(
			(retailer,index) => <Retailer
									key={ index }
									retailer={ retailer }
									productModelNumber={ this.props.product.overView.modelNumber }
								/>
			);

			this.setState({
				currentCountry: 'Canada',
				currentRetailers: rca
			});	
		} else if (element.value === 'UK') {
			const ruk = detail.retailersUk.map(
			(retailer,index) => <Retailer
									key={ index }
									retailer={ retailer }
									productModelNumber={ this.props.product.overView.modelNumber }
								/>
			);

			this.setState({
				currentCountry: 'United Kingdom',
				currentRetailers: ruk
			});	
		}
		global.dataLayer.push({
			event: 'Where to Buy',
			eventCategory: 'Where to Buy',
			eventAction: 'Dropdown',
			eventLabel: element.options[element.selectedIndex].text
		});
	}

	render() {	
		const productModel = this.props.product.overView;

		let options = [];
		if (productModel.hatchDetail.retailersUs.length > 0) options.push({ value: 'US',label: 'United States' });
		if (productModel.hatchDetail.retailersCa.length > 0) options.push({ value: 'CA',label: 'Canada' });
		if (productModel.hatchDetail.retailersUk.length > 0) options.push({ value: 'UK',label: 'United Kingdom' });

		const selectOptions = options.map(
			(opt,index) => <option key={ index } value={ opt.value }>{ opt.label }</option>
		);

		const capacity = this.props.standard ?
			`${productModel.stdCapacity} cubic ft` : `${productModel.mtcCapacity} cubic liter`;
		
		return (
			<div className="hatch">
				<Helmet defer={false}>
					<script async src={ `${config.bazaarVoiceScriptUrl}` }></script>    
				</Helmet>
			
				<div className="col sm-6 main-features">
					<ul>
						<li className="category-name">{ this.props.product.overView.description }</li>
						<li className="size-model">
							<span className="size">{ productModel.size }</span>
							<span> Model { productModel.modelNumber }</span>
						</li>
						<li>Interior Capacity { capacity }</li>
						<li>Price Range&#58; { this.props.product.priceBucket }</li>
						<li className="image">
							<img
								alt={ productModel.modelNumber }
								src={ productModel.capacityImage }
							/>
						</li>
					</ul>
				</div>
				
				<div className="col sm-6 retailers">					
					<div className="country-select">
						<h3>Displaying retail options for {this.state.currentCountry}.</h3>
						<label htmlFor="country" className="assistive-text">Country</label>
						<select
							className="country-list"
							id="country"
							name="country"
							onChange={ e => this.handleChange(e) }
						>
							<option value="">-- Select a different country --</option>
							{ selectOptions }
						</select>	
					</div>
					<ul>
						{ this.state.currentRetailers }
					</ul>													
				</div>
				<div className="text-right">This service is subject to the following <TrackedLink to="https://www.gethatch.com/downloads/legal/Terms-of-Use-%28July-2020%29.pdf" target="_blank">terms</TrackedLink> and <TrackedLink to="https://www.gethatch.com/en/privacy-statement/" target="_blank">privacy policy</TrackedLink>.</div>
				<div className="hatch-power"><div className="hatch-power-txt">Powered By </div><img
					src={ require('../../resources/img/where-to-buy/powered-by-hatch.svg') }
					alt="Powered By Hatch"
				/>
				</div>
			</div>
		);
	}
}

export default branch({
	retailers: ['products', 'retailers']
}, HatchDetail);


// WEBPACK FOOTER //
// ./src/pages/product/HatchDetail.js